export default {
    listData:state=>state.listData,
    countMap:state=>state.countMap
};
